<template>
	<div>
		<template v-if="data">
			<div class="d-block px-5" id="section-to-print">
				<v-row class="w-100">
					<v-col cols="12" sm="12" md="2"></v-col>
					<v-col cols="12" sm="12" md="8" class="d-flex flex-column justify-content-center text-center">
						<img width="120" height="auto" src="/img/ic-logo.svg" class="d-block mx-auto mb-5">
						<span class="font-weight-bold cl-primary font-size-12">Mitra Baru Anda telah berhasil di daftarkan pada sistem Shines Beauty.</span><br>
						<div class="d-block text-center w-100 my-4 mx-auto">
							<v-row class="d-flex justify-center">
								<v-col cols="4" sm="4" md="4" v-for="(akun, idx) in data" :key="idx">
									<div class="d-block mb-3 mx-auto">
										<v-card outlined width="100%">
											<v-card-title class="d-flex flex-column justify-center">
												<v-avatar size="50">
													<img
														src="assets/image/profile-pict.png"
														:alt="akun.name"
													>
												</v-avatar>
												<h5 class="mb-0 mt-1" style="line-height: 1.5rem;">
													<span>{{ akun.name }}</span><br>
													<span class="cl-secondary">{{ akun.code }}</span>
												</h5>
											</v-card-title>
											<v-card-text>
												<span class="d-flex align-center justify-space-between"><span style="display: inline-block;">Sponsor</span><strong>{{ akun.sponsor_network_code }}</strong></span>
												<span class="d-flex align-center justify-space-between"><span style="display: inline-block;">Upline</span><strong>{{ akun.upline_network_code }}</strong></span>
												<span class="d-flex align-center justify-space-between"><span style="display: inline-block;">Posisi</span><strong>{{ akun.position }}</strong></span>
											</v-card-text>
										</v-card>
									</div>
								</v-col>
							</v-row>
						</div>
						Informasikan ke mitra terkait untuk segera login ke website <a :href="this.voUrlOrigin">{{ this.voUrlHost }}</a> dan segera ubah password default tersebut.<p /><span class="font-weight-bold">Salam sukses bersama Shines Beauty!</span>
					</v-col>
					<v-col cols="12" sm="12" md="2"></v-col>
				</v-row>
			</div>

			<v-row class="mt-5">
				<v-col cols="12">
					<div class="d-flex flex-column align-center justify-content-center pa-3">
						<v-btn large depressed color="grey lighten-1" class="rounded-pill" @click="goPrint">
							<v-icon>mdi-printer-outline</v-icon>
							<span class="pl-2 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">Cetak Bukti Registrasi</span>
						</v-btn>
					</div>
				</v-col>
			</v-row>
		</template>
	</div>
</template>

<script>
// import { mapActions } from 'vuex'
export default {
	data () {
		return {
		}
	},
	computed:{
		
	},
	props: [ 'data', 'voUrlOrigin', 'voUrlHost' ],
	methods: {
		goPrint() {
			window.print()
		}
	},
	mounted() {}
};
</script>

<style lang="scss" scoped>
</style>